import { MutationTree } from 'vuex';
import { PDFMapsByGridNumber, MapState } from './types';

export const mutations: MutationTree<MapState> = {
  setSchemePDFMaps(state: MapState, payload: PDFMapsByGridNumber) {
    state.schemePDFMaps = payload;
  },
};
